import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { adminAPI } from '~/api';

const getMe = createAsyncThunk('admin/getMe', async () => {
  const admin = await adminAPI.getMe();
  return admin;
});

type AdminState = {
  isAdmin: boolean;
  loading: boolean;
};

const initialState: AdminState = {
  isAdmin: false,
  loading: true,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getMe.fulfilled, (state, action) => {
      state.isAdmin = action.payload !== null;
      state.loading = false;
    });
    builder.addCase(getMe.rejected, (state) => {
      state.isAdmin = false;
      state.loading = false;
    });
  },
  selectors: {
    isAdmin: (state) => state.isAdmin,
    loading: (state) => state.loading,
  },
});

export const { reducer: adminReducer, selectors: adminSelectors } = adminSlice;

export const adminThunks = { getMe };
